import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from 'common/services/auth.service';

@Injectable()
export class LoginAuthGuard implements CanActivate {

    constructor(private router: Router) { }

    /**
     * Gets the first available route from user privileges
     * @param privileges Array of privilege objects
     * @returns The first available route path or null
     */
    private getFirstAvailableRoute(privileges: any[]): string | null {
        if (!privileges || privileges.length === 0) {
            return null;
        }

        // Map pageType to route (similar to menu component logic)
        for (const permission of privileges) {
            if (permission.pageType === "Dashboard") {
                return "/dashboard";
            }
            if (permission.pageType === "Member Management") {
                return "/members";
            }
            if (permission.pageType === "Activity Logs") {
                return "/activity-logs";
            }
            if (permission.pageType === "Setting" && permission.pageName === "User Management") {
                return "/settings";
            }
            if (permission.pageType === "Trainer Dashboard") {
                return "/trainer-dashboard";
            }

            if (permission.pageType === "Products" && permission.pageName === "Products Listing") {
                return "/products-listing";
            }
            if (permission.pageType === "Purchasing" && permission.pageName === "Suppliers") {
                return "/suppliers-listing";
            }
            if (permission.pageType === "Sales" && permission.pageName === "Point of Sales") {
                return "/point-of-sale";
            }

        }

        return null;
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (!AuthService.getLoggedInUser()) {
            //not logged in so redirect to login page
            return true;
        }

        // Get the first available route from privileges
        const currentRole = AuthService.getLoggedInRole();
        const firstRoute = currentRole?.privileges ? this.getFirstAvailableRoute(currentRole.privileges) : null;
        const defaultRoute = firstRoute || "/members";

        //logged in so redirect to first available privilege page with the return url
        this.router.navigate([defaultRoute], { queryParams: { returnUrl: state.url }});
        return false;
    }
}